import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

const textTokens = {
  dark: {
    primary: 'text.primary',
    secondary: 'text.secondary',
  },
  light: {
    primary: 'light.text.primary',
    secondary: 'light.text.secondary',
  },
} as const

export const formContainerStyles = (
  _colorScheme: ColorScheme = 'dark',
  fillHeight = false
): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  ...(fillHeight && { height: '100%' }),
})

export const formHeaderStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}

export const formTitleStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  textStyle: 'heading-l',
  color: textTokens[colorScheme].primary,
  margin: 0,
})

export const formDescriptionStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  textStyle: 'body',
  color: textTokens[colorScheme].secondary,
  margin: 0,
})

export const formBodyStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}

export const formFooterStyles = (fillHeight = false): SystemStyleObject => ({
  display: 'flex',
  justifyContent: 'flex-end',
  ...(fillHeight && { marginTop: 'auto' }),
})

export const formSectionStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  gap: '32px',
  alignItems: 'flex-start',
}

export const formSectionLabelAreaStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flexShrink: '0',
  width: '240px',
}

export const formSectionTitleStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  textStyle: 'label',
  color: textTokens[colorScheme].primary,
  margin: 0,
})

export const formSectionDescriptionStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  textStyle: 'caption',
  color: textTokens[colorScheme].secondary,
  margin: 0,
})

export const formSectionBodyStyles: SystemStyleObject = {
  flex: '1 0 0',
  minWidth: '0',
  alignSelf: 'stretch',
}
